// Supprimer un client — DÉFINITIVEMENT.
//
// CE QUE CET ÉCRAN DÉCLENCHE : l'effacement des véhicules, des inspections,
// des photos, des documents, des comptes et du journal d'un client. Il n'y a
// pas de corbeille, pas d'annulation, et la sauvegarde de la nuit précédente
// est le seul retour arrière — c'est-à-dire un retour arrière qui perd la
// journée.
//
// DEMANDÉ « en cas d'erreur » (un client créé de travers), mais c'est aussi
// l'outil du droit à l'effacement RGPD. D'où le choix, arrêté avec Yanis, de
// NE PAS bloquer la suppression d'un client qui a des données : refuser
// au-delà d'un seuil protégerait de la faute de frappe et empêcherait de tenir
// une obligation légale. On annonce ce qui va disparaître, et l'éditeur décide.
//
// LA BARRIÈRE EST LA RECOPIE DE L'IDENTIFIANT, et elle vient du serveur : la
// route exige le slug exact en paramètre. L'écran ne fait que la refléter.
//
// POURQUOI PAS UN « Êtes-vous sûr ? » : une question fermée devient un
// réflexe — au troisième client, on clique « oui » avant d'avoir lu. C'est
// l'entrée 20 du carnet d'erreurs, et elle vaut ici plus que partout ailleurs.
// Un identifiant qu'il faut recopier ne se tape pas par accident.
import { useState } from "react";

import api from "../api";

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function SupprimerClient({ client, onFermer, onChange }) {
  const [saisie, setSaisie] = useState("");
  const [erreur, setErreur] = useState("");
  const [enCours, setEnCours] = useState(false);
  const [resultat, setResultat] = useState(null);

  const correspond = saisie.trim() === client.slug;

  const supprimer = () => {
    setEnCours(true);
    setErreur("");
    api
      .delete(`/plateforme/clients/${client.id}`, {
        params: { confirmation: saisie.trim() },
      })
      .then(({ data }) => {
        // LE COMPTE-RENDU DU SERVEUR EST AFFICHÉ TEL QUEL, y compris quand il
        // annonce une suppression INCOMPLÈTE. Une fenêtre qui se refermerait
        // sur un « c'est fait » laisserait croire que tout est parti alors
        // qu'il resterait des lignes — le pire des messages pour du RGPD.
        setResultat(data);
        onChange?.();
      })
      .catch((err) => setErreur(messageErreur(err, "Suppression impossible.")))
      .finally(() => setEnCours(false));
  };

  if (resultat) {
    return (
      <div className="modal-overlay" onClick={onFermer}>
        <div className="modal-carte" onClick={(e) => e.stopPropagation()}>
          <h3 className="modal-titre">
            {resultat.supprime ? "Client supprimé" : "Suppression incomplète"}
          </h3>
          <p className={resultat.supprime ? "sous-info" : "erreur"}>
            {resultat.message}
          </p>
          {!resultat.supprime && (
            <p className="sous-info">
              Il reste {resultat.restant} ligne(s). Ne pas recréer le client
              avant d’avoir compris ce qui subsiste : le détail est dans la
              réponse du serveur, et la cause est presque toujours une table
              absente de <code>rgpd.TABLES</code>.
            </p>
          )}
          <div className="modal-actions">
            <button className="btn-accent" onClick={onFermer}>
              Fermer
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onFermer}>
      <div className="modal-carte" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-titre">Supprimer définitivement ce client</h3>
        <p className="modal-sous-titre">{client.nom}</p>

        {erreur && <p className="erreur">{erreur}</p>}

        {/* CE QUI VA DISPARAÎTRE, EN CHIFFRES. Une confirmation redit ce qui
            va être fait, elle ne demande pas d'approuver une intention : les
            deux nombres viennent de la liste des clients, donc du serveur. */}
        <div className="bloc-danger">
          <p>
            <strong>
              {client.nb_vehicules} véhicule
              {client.nb_vehicules > 1 ? "s" : ""}
            </strong>{" "}
            et{" "}
            <strong>
              {client.nb_utilisateurs} compte
              {client.nb_utilisateurs > 1 ? "s" : ""}
            </strong>{" "}
            vont être effacés, avec les inspections, les photos, les documents,
            le stock, les financements et le journal.
          </p>
          <p className="note-discrete">
            Il n’y a pas de corbeille. Le seul retour arrière est la sauvegarde
            de la nuit dernière — donc au prix de la journée écoulée.
          </p>
        </div>

        <label className="champ">
          <span className="champ-label">
            Pour confirmer, recopiez l’identifiant du client :{" "}
            <code>{client.slug}</code>
          </span>
          <input
            value={saisie}
            onChange={(e) => setSaisie(e.target.value)}
            placeholder={client.slug}
            disabled={enCours}
            autoComplete="off"
          />
        </label>

        <div className="modal-actions">
          <button className="btn" onClick={onFermer} disabled={enCours}>
            Annuler
          </button>
          <button
            className="btn-danger"
            onClick={supprimer}
            disabled={enCours || !correspond}
          >
            {enCours ? "Suppression…" : "Supprimer définitivement"}
          </button>
        </div>
      </div>
    </div>
  );
}
